import axios from 'axios';
import i18n from 'i18next';
import {ButtonProps, showNotification} from 'platform/components';
import {match} from 'ts-pattern';

import {buildArray} from 'shared/web';

import type {AsyncExportDataRequestBody, DataExportAcceptedResponseBody} from '../types/api/data';
import type {ApiContext} from './types';

const TEN_SECONDS = 10 * 1000;

export function createExportApi(ctx: ApiContext) {
  const BASE = `/v6/data-grid/${ctx.gridCode}`;

  return {
    postExport: (params: AsyncExportDataRequestBody) =>
      axios
        .post(`${BASE}/export`, params)
        .then((response) => {
          showNotification.success(i18n.t('page.datagrid.exportSuccessful'), {
            layout: 'detailed',
            secondaryMessage: i18n.t('page.datagrid.exportSuccessfulDescription'),
            autoClose: TEN_SECONDS,
            // The exports table lives in DMS only, so the link is DMS-specific.
            actions: buildArray<ButtonProps>().when(ctx.app === 'dms', {
              type: 'button',
              title: i18n.t('page.datagrid.showExportsTable'),
              variant: 'link',
              onClick: () => window.location.assign('/my-profile/table-exports'),
            }),
          });
          return response.data as DataExportAcceptedResponseBody;
        })
        .catch(
          (error: {
            response?: {status?: number; data?: {errors?: {message?: string}[]}};
            message?: string;
          }) => {
            const status = error?.response?.status;
            const errorMessage = error?.response?.data?.errors?.[0]?.message ?? error?.message;

            match(status)
              .with(403, () => showNotification.error(i18n.t('general.notifications.noPermission')))
              .otherwise(() => showNotification.error(errorMessage));
          }
        ),
  };
}
